<template>
    <div 
    class="note" 
    draggable="true"  
    @drag="makeAbsolute($event)"
    @dragend="finalPosition($event)" 
    @drop.prevent
    :style="'background:'+ colors[activeColor]"
    
    >
        <div class="header__note">
            <div class="d-flex justify-content-between align-items-center">
                <div class="trash" @click="deleteMe(ni)">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 3C1 2.72386 1.22386 2.5 1.5 2.5H10.5C10.7761 2.5 11 2.72386 11 3C11 3.27614 10.7761 3.5 10.5 3.5H1.5C1.22386 3.5 1 3.27614 1 3Z" fill="#474D52"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5 1.5C4.86739 1.5 4.74022 1.55268 4.64645 1.64645C4.55268 1.74021 4.5 1.86739 4.5 2V2.5H7.5V2C7.5 1.86739 7.44732 1.74021 7.35355 1.64645C7.25979 1.55268 7.13261 1.5 7 1.5H5ZM8.5 2.5V2C8.5 1.60217 8.34196 1.22064 8.06066 0.93934C7.77936 0.658035 7.39782 0.5 7 0.5H5C4.60218 0.5 4.22064 0.658035 3.93934 0.93934C3.65804 1.22064 3.5 1.60217 3.5 2V2.5H2.5C2.22386 2.5 2 2.72386 2 3V10C2 10.3978 2.15804 10.7794 2.43934 11.0607C2.72064 11.342 3.10217 11.5 3.5 11.5H8.5C8.89783 11.5 9.27936 11.342 9.56066 11.0607C9.84196 10.7794 10 10.3978 10 10V3C10 2.72386 9.77614 2.5 9.5 2.5H8.5ZM3 3.5V10C3 10.1326 3.05268 10.2598 3.14645 10.3536C3.24021 10.4473 3.36739 10.5 3.5 10.5H8.5C8.63261 10.5 8.75978 10.4473 8.85355 10.3536C8.94732 10.2598 9 10.1326 9 10V3.5H3Z" fill="#474D52"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5 5C5.27614 5 5.5 5.22386 5.5 5.5V8.5C5.5 8.77614 5.27614 9 5 9C4.72386 9 4.5 8.77614 4.5 8.5V5.5C4.5 5.22386 4.72386 5 5 5Z" fill="#474D52"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7 5C7.27614 5 7.5 5.22386 7.5 5.5V8.5C7.5 8.77614 7.27614 9 7 9C6.72386 9 6.5 8.77614 6.5 8.5V5.5C6.5 5.22386 6.72386 5 7 5Z" fill="#474D52"/>
                    </svg>
                </div>
                <div class="share">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9 1.5C8.44772 1.5 8 1.94772 8 2.5C8 3.05228 8.44772 3.5 9 3.5C9.55228 3.5 10 3.05228 10 2.5C10 1.94772 9.55228 1.5 9 1.5ZM7 2.5C7 1.39543 7.89543 0.5 9 0.5C10.1046 0.5 11 1.39543 11 2.5C11 3.60457 10.1046 4.5 9 4.5C7.89543 4.5 7 3.60457 7 2.5Z" fill="#474D52"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3 5C2.44772 5 2 5.44772 2 6C2 6.55228 2.44772 7 3 7C3.55228 7 4 6.55228 4 6C4 5.44772 3.55228 5 3 5ZM1 6C1 4.89543 1.89543 4 3 4C4.10457 4 5 4.89543 5 6C5 7.10457 4.10457 8 3 8C1.89543 8 1 7.10457 1 6Z" fill="#474D52"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9 8.5C8.44772 8.5 8 8.94772 8 9.5C8 10.0523 8.44772 10.5 9 10.5C9.55228 10.5 10 10.0523 10 9.5C10 8.94772 9.55228 8.5 9 8.5ZM7 9.5C7 8.39543 7.89543 7.5 9 7.5C10.1046 7.5 11 8.39543 11 9.5C11 10.6046 10.1046 11.5 9 11.5C7.89543 11.5 7 10.6046 7 9.5Z" fill="#474D52"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.06626 6.68027C4.20529 6.44168 4.51141 6.36097 4.75 6.5L7.75 8.25C7.98859 8.38903 8.0693 8.69515 7.93027 8.93374C7.79123 9.17233 7.48511 9.25304 7.24652 9.11401L4.24652 7.36401C4.00793 7.22498 3.92723 6.91885 4.06626 6.68027Z" fill="#474D52"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.92983 3.06614C8.06901 3.30464 7.9885 3.61082 7.75 3.75L4.75403 5.61369C4.51553 5.75287 4.20935 5.67236 4.07017 5.43386C3.93099 5.19536 4.0115 4.88918 4.25 4.75L7.24597 2.88631C7.48447 2.74713 7.79065 2.82764 7.92983 3.06614Z" fill="#474D52"/>
                    </svg>
                </div>

               <div class="d-flex justify-content-between align-items-center">
                    <div 
                    class="color" 
                    v-for="(color, ci) in colors"
                    :key="color"
                    :style="'background:'+ color"
                    @click="changeColor(ci,ni )"
                    v-if="activeColor!=ci"
                    >
                    </div>
                </div>
            </div>
        </div>
        <div class="body__note" v-b-modal.modal-center @click="emitId(ni)">
            <p class="content" >
                {{content}}
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Note.vue",
        props: ['activeColor', 'content', 'ni'],
        data(){
            return{
              pos1 :0,
              pos2 : 0,
              pos3 : 0,
              pos4 : 0,
              colors: [
                  '#C4E2B8',
                  '#AFE0EC',
                  '#CFBCDC',
                  '#FFFF8D',
                  '#FFFFFF',
                  '#F4C0CB'
              ]
            }
        },
        computed: {

        },

        methods: {
            emitId(ni){
                this.$emit('editMe', {ni: ni})
            },
            deleteMe(ni){
                this.$emit('deleteMe', {ni: ni})
            },
            makeAbsolute(e){
                 e = e || window.event;
                e.preventDefault();
                // get the mouse cursor position at startup:
                this.pos3 = e.clientX;
                this.pos4 = e.clientY;
                e.target.style.visibility = 'hidden'
                // e.target.style.top = e.pageY-110 + "px";
                // e.target.style.left = e.pageX-60  + "px";
            },
            finalPosition(e){
                e.target.style.position = 'absolute'
                e.target.style.top = e.pageY-120 + "px";
                e.target.style.left = e.pageX-65  + "px";
                e.target.style.visibility = 'visible'
            },
            changeColor(ci, ni){
                this.$emit('changeNoteColor', {ci:ci, ni:ni})
            }
            
        }
    }
</script>

<style lang="scss" scoped>
    .note{
        width: 144px;
        height: 154px;
        padding: 5px;
        background-color: #fff;
        .color{
            width: 12px;
            height: 12px;
            border-radius: 50%;
            margin-right: 6px;
            cursor: pointer;
        }

        .trash,
        .share{
            cursor: pointer;
        }
        .body__note{
            height: 85%;
        }
        .content{
            font-family: 'Nunito', sans-serif;
            font-size: 10px;
            line-height: 14px;
            color: #474D52;
            margin: 0;
        }
    }
</style>